import React from 'react';

import { MenuItem, Select } from '@material-ui/core';
import { SelectInputProps } from '@material-ui/core/Select/SelectInput';

import { getCustomerLogoPath } from '../util/get-customer-logo-path';
import { sortAlphabetically, SORT_ORDER } from '../util/sort-functions';

type InputProps = {
  className?: string;
  disableUnderline?: boolean;
  extraOptions?: React.ReactNode[];
  onChange: SelectInputProps['onChange'];
  orgOptions: Org[];
  value?: string | number;
};

export const OrgSelect = ({
  className,
  disableUnderline,
  extraOptions,
  onChange,
  orgOptions,
  value,
}: InputProps) => (
  <Select
    className={className}
    // Hardcoded so that the select height doesn't change if we default to an option without photos
    style={{ minHeight: '71px', width: '100%' }}
    onChange={onChange}
    value={value}
    disableUnderline={disableUnderline}
  >
    {extraOptions}
    {orgOptions.sort(sortAlphabetically((o) => o.name, SORT_ORDER.ASC)).map((o) => (
      <MenuItem key={o.org_id} value={o.org_id}>
        <div className="u-display-flex u-width-100 u-alightItems-center">
          <div className="navDropdown-imageContainer">
            <img className="navDropdown-image" src={getCustomerLogoPath(o)} alt={o.name} />
          </div>
          <div className="navDropdown-nameContainer">
            <div className="navDropdown-name">{o.name}</div>
          </div>
        </div>
      </MenuItem>
    ))}
  </Select>
);
